import { useState } from 'react';

const faqs = [
  {
    q: '漫画网如何按题材分类找漫画？',
    a: '进入「题材分类」页面后，可以看到热血冒险、玄幻修仙、恋爱甜宠、悬疑推理、搞笑日常、科幻末世等六大分类。点击任意分类即可进入对应的漫画列表，快速浏览该题材下的所有作品。',
  },
  {
    q: '如何区分完结漫画和连载中漫画？',
    a: '每部漫画的封面左上角都会标注「完结」或「连载中」标签。你也可以通过导航栏或分类页的筛选功能，一键查看全部的完结漫画或连载中漫画。',
  },
  {
    q: '可以通过标签找漫画吗？',
    a: '当然可以。在首页的「热门标签找书」板块和分类页中，你可以点击热血、恋爱、科幻等标签，系统会为你筛选出包含该标签的所有漫画。',
  },
  {
    q: '在漫画网看漫画需要注册或付费吗？',
    a: '漫画网提供免费的在线漫画阅读服务，无需注册即可浏览绝大多数内容。部分作品会优先展示最新章节，详情请以页面提示为准。',
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="mx-auto w-full max-w-4xl px-4 py-12 md:px-6 md:py-16" aria-labelledby="faq-title">
      <div className="mb-8 text-center">
        <span className="text-xs font-bold uppercase tracking-widest text-accent-700">常见问题</span>
        <h2 id="faq-title" className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          阅读常见问题
        </h2>
      </div>

      <div className="space-y-3">
        {faqs.map((faq, index) => {
          const open = openIndex === index;
          return (
            <div key={index} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <button
                type="button"
                onClick={() => setOpenIndex(open ? -1 : index)}
                className="flex w-full items-center justify-between px-5 py-4 text-left"
                aria-expanded={open}
              >
                <span className="text-sm font-bold text-foreground-950 md:text-base">{faq.q}</span>
                <span className={`ml-4 flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-transform ${open ? 'rotate-45 bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-700'}`}>
                  <i className="ri-add-line"></i>
                </span>
              </button>
              {open && (
                <p className="border-t border-background-100 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                  {faq.a}
                </p>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default FaqSection;